export const WRITE_PERMISSION_KEYS = {
  ACCOUNTING: "ACCOUNTING",
  DATA_SOURCES: "DATA_SOURCES",
  EXPENSE: "EXPENSE",
  FINANCIALS: "FINANCIALS",
  HOME: "HOME",
  REVENUE: "REVENUE",
  TRANSACTIONS: "TRANSACTIONS",
} as const;

export type WritePermissionKey =
  (typeof WRITE_PERMISSION_KEYS)[keyof typeof WRITE_PERMISSION_KEYS];
